export const baseURlFront = '';

const config = {
    logo: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/akinexlogo.png`
      : '/web-image/akinexlogo.png',

    loader: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/akinexloader.png`
      : '/web-image/akinexloader.png',

    phoneIcon: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/phone-icon.png`
      : '/web-image/phone-icon.png',

    mailIcon: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/mail-icon.png`
      : '/web-image/mail-icon.png',

    heroBg: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/akinex-bg.png`
      : '/web-image/akinex-bg.png',

    image01: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/pre01.jpg`
      : '/web-image/pre01.jpg',

    image02: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/pre02.jpg`
      : '/web-image/pre02.jpg',

    pricing: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/pricing.jpg`
      : '/web-image/pricing.jpg',

    numb2: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/numb2.jpg`
      : '/web-image/numb2.jpg',

    indus: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/indus.jpg`
      : '/web-image/indus.jpg',

    tailored: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/tailored.jpg`
      : '/web-image/tailored.jpg',

    sourcingBg: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/sourcing.png`
      : '/web-image/sourcing.png', 

    keyfactorLogo: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/keyfactor-logo2.png`
      : '/web-image/keyfactor-logo2.png',

    pantheonLogo: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/panthone-logo2.png`
      : '/web-image/panthone-logo2.png',

    hubspotLogo: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/hubspot-logo2.png`
      : '/web-image/hubspot-logo2.png',

    pictureBg: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/metals.webp`
      : '/web-image/metals.webp',

    workerWithPieP: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/workerwithpiep.jpg`
      : '/web-image/workerwithpiep.jpg',
    
    plate: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/plate.jpg`
      : '/web-image/plate.jpg',
    
    bars: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/bars.jpg`
      : '/web-image/bars.jpg',

    footerLogo: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/akinexlogo.png`
      : '/web-image/akinexlogo.png',

    quoteSectionImage: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/user.jpeg`
      : '/web-image/user.jpeg',

    visionL: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/vision-left.jpg`
      : '/web-image/vision-left.jpg',

    visionR: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/vision-right.jpg`
      : '/web-image/vision-right.jpg',

    visionB: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/vision-bottom.jpg`
      : '/web-image/vision-bottom.jpg',

    globeV: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/globe-vision.png`
      : '/web-image/globe-vision.png',

    truckV: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/truck-vision.png`
      : '/web-image/truck-vision.png',
      
    userT: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/users-vision.png`
      : '/web-image/users-vision.png',
      
    solidbar: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/solidbars.jpg`
      : '/web-image/solidbars.jpg',

    titbar: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/titnumbars.jpg`
      : '/web-image/titnumbars.jpg',

    flags: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/flags.jpg`
      : '/web-image/flags.jpg',

    serviceheader: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/serviceheader.jpg`
      : '/web-image/serviceheader.jpg',

    missionimage: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/missionimage.jpg`
      : '/web-image/missionimage.jpg',

    // Values Section Images
    values01: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/values01.jpg`
      : '/web-image/values01.jpg',

    values02: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/values02.jpg`
      : '/web-image/values02.jpg',

    values03: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/values03.jpg`
      : '/web-image/values03.jpg',

    values04: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/values04.jpg`
      : '/web-image/values04.jpg',

    productheader: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/productheader.jpg`
      : '/web-image/productheader.jpg',

    careerheader: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/career3.jpg`
      : '/web-image/career3.jpg',

    culture01: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/culture01.jpg`
      : '/web-image/culture01.jpg',

    culture02: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/culture02.jpg`
      : '/web-image/culture02.jpg',

    culture03: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/culture03.jpg`
      : '/web-image/culture03.jpg',

    talent: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/talentpool.jpg`
      : '/web-image/talentpool.jpg',

    product_header: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/productheader2.webp`
      : '/web-image/productheader2.webp',

    market01: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/Market01.jpg`
      : '/web-image/Market01.jpg',

    taylor: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/taylorswift.jpg`
      : '/web-image/taylorswift.jpg',

    shawn: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/Shawn-Mendes-Merch7.png`
      : '/web-image/Shawn-Mendes-Merch7.png',

    harry: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/harry.png`
      : '/web-image/harry.png',

    chester: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/chester.png`
      : '/web-image/chester.png',

      who_we: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/whoweare.jpg`
      : '/web-image/whoweare.jpg',

      whatwedo: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/whatwedo.webp`
      : '/web-image/whatwedo.webp',

      akinexplaceholder: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/akinex-placeholder.png`
      : '/web-image/akinex-placeholder.png',
      
      whyWorkWithUs: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/executive-touching-icon-social-network.webp`
      : '/web-image/executive-touching-icon-social-network.webp',

      productDrawing: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/ProductDrawing.webp`
      : '/web-image/ProductDrawing.webp',

      sourcing23: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/sourcing-process.webp`
      : '/web-image/sourcing-process.webp',

      concept: process.env.NODE_ENV === 'production'
      ? `${baseURlFront}/web-image/concept-with.avif`
      : '/web-image/concept-with.avif',


    favicon: process.env.NODE_ENV === 'production'
      ? '/favicon.ico'  
      : '/favicon.ico',

};


//whatwedo.webp
export const baseURl = 'https://akinex-api.algosu.com';



// export const baseURl = 'http://localhost:3031';

export default config;